import FreeLocalizationService from './FreeLocalizationService';
import { FreeLocalizationServiceInterface } from './interface';

// Фабрика сервиса локализации виджета
export const freeLocalizationService: {
  (): FreeLocalizationServiceInterface;
} = () => {
  return new FreeLocalizationService();
};
